import { Component, Inject, OnInit } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { MatSelectionListChange } from '@angular/material/list'
import { CommandeSettingsArticles, SettingsArticles } from '../shared/commande-param-settings'

@Component({
  selector: 'app-commande-settings-modal',
  templateUrl: './commande-param-settings-modal.component.html',
  styleUrls: [
    './commande-param-settings-modal.component.scss'
  ]
})
export class CommandeParamSettingsModalComponent implements OnInit {

  article: CommandeSettingsArticles[] = []

  constructor(
    public dialogRef: MatDialogRef<CommandeParamSettingsModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SettingsArticles,
  ) { }

  ngOnInit(): void {
  }

  changeValue($event: MatSelectionListChange) {
    if ($event.options[0].selected) {
      this.article.push($event.options[0].value)
    } else {
      this.article = this.article.filter(item => item != $event.options[0].value)
    }
  }

  refuse() {
    this.dialogRef.close(false);
  }
}
